import { render, staticRenderFns } from "./headMeun.vue?vue&type=template&id=6b460c5c&scoped=true&"
import script from "./headMeun.vue?vue&type=script&lang=js&"
export * from "./headMeun.vue?vue&type=script&lang=js&"
import style0 from "./headMeun.vue?vue&type=style&index=0&id=6b460c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b460c5c",
  null
  
)

export default component.exports